import ExternalAccountForm from '@/components/externalAccounts/form/ExternalAccountForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { initialExternalAccountForm } from '@/constants/externalAccounts';
import { ROUTES } from '@/constants/routes';
import { useGetUser } from '@/hooks/requests/useUser';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ExternalAccountsAddPage() {
  const navigate = useNavigate();
  const { isStaff } = useAuthUser();
  const { user } = useGetUser();

  return (
    <DefaultLayout
      header="Add External Account"
      subheader={
        <Typography>
          To link an external account, please fill in the following details
        </Typography>
      }>
      <ExternalAccountForm
        defaultValues={{
          ...initialExternalAccountForm,
          companyId: isStaff ? '' : user?.teammateInfo?.company.uuid || '',
        }}
        onLeave={() => navigate(ROUTES.EXTERNAL_ACCOUNTS)}
        onSuccess={(uuid: string) =>
          navigate(`${ROUTES.EXTERNAL_ACCOUNTS}/${uuid}`)
        }
      />
    </DefaultLayout>
  );
}
